<template>
  <div class="card-aside">
    <el-menu
      :default-active="defaultActive"
      active-text-color="#009CFF"
    >
      <div
        v-for="item in menuList"
        :key="item.title"
      >
        <div class="title">
          {{ item.title }}
        </div>
        <template v-if="item.list"></template>
        <el-menu-item
          v-for="(listItem, listIndex) in item.list"
          :key="listIndex"
          :index="listItem"
          @click="onChoose(listItem)"
        >
          <span slot="title">{{ listItem }}</span>
          <i class="el-icon-arrow-right"></i>
        </el-menu-item>
      </div>
    </el-menu>
    <div class="footer">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardAside',
  props: {
    menuList: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultActive: {
      type: String,
      default: ''
    }
  },
  methods: {
    onChoose (curTitle) {
      this.$emit('on-select', curTitle)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-aside {
  background-color: #fff;
  width: 200px;
  height: 100%;
  position: relative;
  border-right: 1px solid #e8e8e8;

  .title {
    height: 54px;
    line-height: 54px;
    padding: 0 0 0 20px;
  }

  .el-icon-arrow-right {
    float: right;
    margin: 11px 0 0;
  }

  /deep/ .el-menu {
    border-right: none;
  }

  /deep/ .el-menu-item {
    height: 40px;
    line-height: 40px;
    padding-right: 14px;
    color: #595959;

    &:hover {
      background-color: #dbf1ff;
    }
  }

  /deep/ .el-menu-item.is-active {
    background-color: #dbf1ff;
  }

  .footer {
    position: absolute;
    bottom: 60px;
  }
}
</style>
